import React from "react";
import {withRouter} from "react-router-dom";
import SettingsProfileContainer from "./profile/settings_profile_container";
import SettingsCompanyContainer from "./company/settings_company_container";
import SettingsPreferencesContainer from "./preferences/settings_preferences_container";
import SettingsServicesContainer from "./services/settings_service_container";
import SettingsTimeSlotsContainer from "./times/settings_time_slots_container";
import SettingsPaymentContainer from "./payments/settings_payment_container";
import SettingsUsersContainer from "./users/settings_users_container";
import VirtualStagingEditContainer from "./virtual-staging/virtual_staging_edit_container";
import SettingsFirmsContainer from "./firms/settings_firms_container";
import SettingsGalleryContainer from "./gallery/settings_gallery_container";
import SettingsPayoutsContainer from "./payouts/settings_payouts_container";
import SettingsTermsOfServiceContainer from "./terms-of-service/settings_terms_of_service_container";
import SettingsSubBrokersContainer from "./sub-brokers/settings_sub_brokers_container";
import SettingsFaqsContainer from "./faq/settings_faqs_container";
import SettingsPromosContainer from "./promo/settings_promos_container";
import SettingsTimesContainer from "./times/settings_times_container";
import SettingsZipcodesContainer from "./zip-codes/settings_zipcodes_container"
import SettingsAdsContainer from "./ads/settings_ads_container";
import SettingsBlogCategoriesContainer from "./blogs/blog_categories_container";
import SettingsBundlesContainer from "./bundles/bundles_container";
import SettingsDiscountCodesContainer from "./discount_codes/discount_codes_container";
import SettingsAssignedDiscountCodesContainer from "./assigned_discount_codes/assigned_discount_codes_container";
import SettingsLocationsContainer from "./locations/settings_locations_container";
import SettingsMilestonesContainer from "./milestones/settings_milestones_container";
import SettingsContractorsContainer from "./contractors/settings_contractors_container";
import SettingsNotificationsContainer from "./notifications/settings_notifications_container";
import SettingsAlertsContainer from "./alerts/settings_alerts_container";
import SettingsLocationPricesContainer from "./location_prices/settings_location_prices_container";
import SettingsSalesDataContainer from "./revenue/settings_revenue_container";
import UploadTrackerAdminContainer from "./upload_tracker/settings_upload_tracker_container";
import SettingsAdminContainer from "./admin_settings/admin_settings_container"
import PhotographerStatsContainer from "./photographer_stats/photographer_stats_container";
import TourAnalytics from "./tour_analytics/tour_analytics";
import RevenueChartContainer from "./revenue_chart/revenue_chart_container";

const TAB_GROUPS = [
  { label: "Listings",   tabs: ['services', 'location_pricing', 'bundles', 'discount_codes', 'auto_apply_coupons', 'locations', 'firms', 'zipcodes'] },
  { label: "Content",    tabs: ['blogs', 'faq', 'terms-of-service', 'ads', 'promos', 'virtual-staging', 'gallery'] },
  { label: "People",     tabs: ['users', 'contractors', 'photographer_stats', 'sub-brokers'] },
  { label: "Operations", tabs: ['times', 'time-slots', 'milestones', 'notifications', 'alerts', 'uploads', 'revenue', 'tour_analytics', 'revenue_chart'] },
  { label: "Account",    tabs: ['profile', 'company', 'payment', 'payouts', 'preferences', 'admin_settings'] }
];

class SettingsMain extends React.Component {
  constructor(props) {
    super(props);

    const userTabs = this.visibleUserTabs(this.props.currentUser)

    const urlTab  = this.props.match.params.tab
    this.state = {
      activeTab: urlTab && userTabs.includes(urlTab) ? urlTab : 'profile',
      openGroup: null
    }

    this.updateActiveTab = this.updateActiveTab.bind(this)
    this.toggleGroup = this.toggleGroup.bind(this)
  }

  updateActiveTab(activeTab) {
    this.setState({activeTab, openGroup: null})

    this.props.history.push({
      pathname: `/settings/${activeTab}`,
    })
  }

  toggleGroup(label) {
    this.setState(prev => ({ openGroup: prev.openGroup === label ? null : label }))
  }

  tab(tab) {
    const tabs = {
      profile: {component: <SettingsProfileContainer logout={this.props.logout} />, label: 'Profile'},
      services: {component: <SettingsServicesContainer/>, label: 'Services'},
      users: {component: <SettingsUsersContainer />, label: 'Users'},
      'virtual-staging': {
        component: <VirtualStagingEditContainer/>,
        label: this.props.isLargeScreen ? 'Virtual Staging' : "VS"
      },
      firms: {component: <SettingsFirmsContainer/>, label: 'Firms'},
      'terms-of-service': {
        component: <SettingsTermsOfServiceContainer/>,
        label: this.props.isLargeScreen ? 'ToS' : 'ToS'
      },
      gallery: {component: <SettingsGalleryContainer/>, label: 'Gallery'},
      'time-slots': {component: <SettingsTimeSlotsContainer/>, label: 'Timeslots'},
      payouts: {component: <SettingsPayoutsContainer/>, label: 'Payment Info'},
      preferences: {component: <SettingsPreferencesContainer/>, label: 'Preferences'},
      company: {component: <SettingsCompanyContainer/>, label: 'Company'},
      payment: {component: <SettingsPaymentContainer/>, label: 'Payment Method'},
      'sub-brokers': {component: <SettingsSubBrokersContainer />, label: 'Agents'},
      faq: {component: <SettingsFaqsContainer />, label: 'FAQ'},
      ads: {component: <SettingsAdsContainer />, label: 'Ads'},
      promos: {component: <SettingsPromosContainer />, label: 'Promos'},
      times: { component: <SettingsTimesContainer isLargeScreen={this.props.isLargeScreen}/>, label: 'Times'},
      zipcodes: {component: <SettingsZipcodesContainer />, label: 'Service Area'},
      blogs: {component: <SettingsBlogCategoriesContainer />, label: 'Blogs'},
      bundles: {component: <SettingsBundlesContainer />, label: "Bundles"},
      discount_codes: {component: <SettingsDiscountCodesContainer />, label: "Coupons"},
      auto_apply_coupons: {component: <SettingsAssignedDiscountCodesContainer />, label: "Auto-Apply Coupons"},
      locations: {component: <SettingsLocationsContainer />, label: "Locations"},
      milestones: {component: <SettingsMilestonesContainer />, label: "Milestones" },
      contractors: {component: <SettingsContractorsContainer />, label: "Contractors"},
      notifications: {component: <SettingsNotificationsContainer />, label: "Notifications"},
      alerts: {component: <SettingsAlertsContainer />, label: "Alerts"},
      location_pricing: {component: <SettingsLocationPricesContainer />, label: "Location Pricing"},
      revenue: {component: <SettingsSalesDataContainer />, label: "Revenue"},
      uploads: {component: <UploadTrackerAdminContainer />, label: "Uploads"},
      admin_settings: {component: <SettingsAdminContainer />, label: "Admin Settings"},
      photographer_stats: {component: <PhotographerStatsContainer />, label: "Photographer Stats"},
      tour_analytics: {component: <TourAnalytics />, label: "Tour Analytics"},
      revenue_chart: {component: <RevenueChartContainer />, label: "Revenue Chart"}

    }

    return tabs[tab]
  }

  visibleUserTabs(currentUser) {
    const userTabs = Array.from(new Set(
      Object.keys(currentUser.super_admin ? {super_admin: true} : currentUser.roles).flatMap(role => this.roleTabs(role))
    ))

    const firmFullyChargesBroker = currentUser.roles?.sub_broker && currentUser.firm?.broker_charge && currentUser.firm?.broker_charge_virtual_staging

    return firmFullyChargesBroker ? userTabs.filter(tab => tab !== 'payment') : userTabs
  }

  roleTabs(role) {
    const tabs = {
      super_admin: ['profile', 'services', 'users', 'virtual-staging', 'firms', 'terms-of-service', 'faq', 'ads', 'promos', 'times', 'blogs', 'bundles', 'discount_codes', 'auto_apply_coupons', 'locations', 'milestones', 'contractors', 'notifications', "location_pricing", "revenue", "uploads", "admin_settings", "photographer_stats", "tour_analytics", "revenue_chart"],
      admin: ['profile', 'users', 'times', 'discount_codes', "uploads"],
      contractor: ['profile', 'gallery', 'time-slots', 'zipcodes', 'payouts', 'alerts'],
      broker: ['profile', 'company', 'sub-brokers'],
      post_production: ['profile'],
      sales_rep: ['profile', 'payouts'],
      default: ['profile', 'payment', 'tour_analytics']
    }

    return tabs[role] || tabs.default
  }

  // Build the visible groups for this user: each group filtered to tabs they can see,
  // plus a catch-all for any visible tab not assigned to a group. Empty groups drop out.
  visibleGroups(userTabs) {
    const grouped = new Set()
    const groups = TAB_GROUPS.map(group => {
      const tabs = group.tabs.filter(t => userTabs.includes(t))
      tabs.forEach(t => grouped.add(t))
      return { label: group.label, tabs }
    }).filter(group => group.tabs.length > 0)

    const leftovers = userTabs.filter(t => !grouped.has(t))
    if (leftovers.length > 0) {
      groups.push({ label: "More", tabs: leftovers })
    }
    return groups
  }

  renderGroupedNav(userTabs, isLargeScreen) {
    const groups = this.visibleGroups(userTabs)
    const activeLabel = this.tab(this.state.activeTab)?.label

    return (
      <div className={`settingsGroupedNav ${isLargeScreen ? '' : 'settingsGroupedNavMobile'}`}>
        {groups.map(group => {
          const isOpen = this.state.openGroup === group.label
          const containsActive = group.tabs.includes(this.state.activeTab)
          return (
            <div className={`settingsNavGroup${isOpen ? ' open' : ''}${containsActive ? ' hasActive' : ''}`} key={group.label}>
              <div className="settingsNavGroupHeader" onClick={() => this.toggleGroup(group.label)}>
                <span>{group.label}</span>
                {containsActive && activeLabel && <span className="settingsNavGroupActive">{activeLabel}</span>}
                <span className={`settingsNavCaret${isOpen ? ' up' : ''}`}>▾</span>
              </div>
              {isOpen && (
                <div className="settingsNavGroupItems">
                  {group.tabs.map(tab => (
                    <div
                      key={tab}
                      className={`settingsNavGroupItem${this.state.activeTab === tab ? ' active' : ''}`}
                      onClick={() => this.updateActiveTab(tab)}
                    >
                      {this.tab(tab)?.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  renderFlatNav(userTabs, isLargeScreen) {
    const projectsNavClass = `projectsIndexProjectsNav${isLargeScreen ? '' : 'Mobile'}`
    const projectsNavItemClass = `projectsIndexProjectsNavItem${isLargeScreen ? '' : 'Mobile'}`
    const activeTabId = `projectsIndexProjectsNavActive${isLargeScreen ? '' : 'Mobile'}`

    return (
      <div className={projectsNavClass} id="settingsNavClass">
        {userTabs.map(tab =>
          <div onClick={() => this.updateActiveTab(tab)} className={projectsNavItemClass}
               key={tab} id={this.state.activeTab === tab ? activeTabId : ''}>
            {this.tab(tab)?.label}
          </div>
        )}
      </div>
    )
  }

  render() {
    const {isLargeScreen, currentUser} = this.props

    const userTabs = this.visibleUserTabs(currentUser)

    const useGroupedNav = currentUser.super_admin || !!currentUser.roles?.admin

    return (
      <div>
        {useGroupedNav
          ? this.renderGroupedNav(userTabs, isLargeScreen)
          : this.renderFlatNav(userTabs, isLargeScreen)}
        <div className="settingsMainComponent">
          {this.tab(this.state.activeTab).component}
        </div>
      </div>
    )
  }
}

export default withRouter(SettingsMain)